module.exports = __webpack_public_path__ + "img/labmemtest_text_nextbtn_kr.77b1e791.png";